import { useMemo } from 'react';

import { ActionDateRange } from 'modules/search/components/Facet/ActionDateRange';
import { LocaleFacet } from 'modules/search/components/Facet/LocaleFacet';
import { LocationTypeFacet } from 'modules/search/components/Facet/LocationTypeFacet';
import { OrgAreasOfFocusFacet } from 'modules/search/components/Facet/OrgAreasOfFocusFacet';
import { RadiusFacet } from 'modules/search/components/Facet/RadiusFacet';
import { RecencyFacet } from 'modules/search/components/Facet/RecencyFacet';
import { SearchRefinements } from 'modules/search/components/Refinements/SearchRefinements';

import { EventSourceFacet } from './EventSourceFacet';

export function SearchEventsRefinements() {
  const refinementsByLocale = useMemo(
    () => ({
      en: [
        LocationTypeFacet,
        OrgAreasOfFocusFacet,
        ActionDateRange,
        EventSourceFacet,
        LocaleFacet,
        RecencyFacet,
        RadiusFacet,
      ],
      es: [
        LocationTypeFacet,
        OrgAreasOfFocusFacet,
        ActionDateRange,
        EventSourceFacet,
        LocaleFacet,
        RecencyFacet,
        RadiusFacet,
      ],
      pt: [
        LocationTypeFacet,
        OrgAreasOfFocusFacet,
        ActionDateRange,
        EventSourceFacet,
        LocaleFacet,
        RecencyFacet,
        RadiusFacet,
      ],
    }),
    [],
  );

  return (
    <SearchRefinements listingType="EVENT">
      {refinementsByLocale[CURRENT_LOCALE()].map((Component) => (
        <Component key={Component.name} />
      ))}
    </SearchRefinements>
  );
}
